import React from 'react';

function Footer({ t }) {
  
  const currentYear = new Date().getFullYear();
  return (
    <footer>
      <hr />
      <div className='main_footer'>
      <a href="#home" className='icon'>nulamar</a>
        <a href='https://youtube.com/@nulamar?feature=shared' className="fa-brands fa-youtube icon" aria-label='YouTube' target='_blank' rel="noopener noreferrer" />
        <a href='https://www.instagram.com/' className="fa-brands fa-instagram icon" aria-label='Instagram' target='_blank' rel="noopener noreferrer" />
      </div>
      <p>© {currentYear}. {t.footer.rights} nulamar.</p>
    </footer>
  );
}

export default Footer;
